(() => {
  const enhance = (scope = document) => {
    scope.querySelectorAll?.('[data-smm-root]').forEach((root) => {
      if (root.dataset.smmFloatingCloseReady === 'true') return;
      root.dataset.smmFloatingCloseReady = 'true';

      const chooser = root.querySelector('[data-smm-chooser]');
      const cancel = root.querySelector('[data-smm-cancel]');
      if (!chooser || !cancel) return;

      chooser.addEventListener(
        'scroll',
        () => chooser.classList.toggle('is-scrolled', chooser.scrollTop > 8),
        { passive: true }
      );

      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || chooser.hidden) return;
        event.preventDefault();
        cancel.click();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else {
    enhance(document);
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
